/* @ngInject */
function SearchResultController ($scope, $rootScope, $timeout, $q, BrandService, BrandFontsService, AssetService, AssetPreviewService, MessageService, ToastService, $translate) {
  $scope.flags = {
    loadingAssets: true,
    loadingFonts: true
  }
  $scope.searchTerm = ''
  $scope.assets = []
  $scope.fonts = []
  $scope.assetsTop = 18
  $scope.fontsTop = 18
  $scope.iTokensCount = $rootScope.isDesktop ? 10 : 5
  $scope.assetsCount = 0
  $scope.fontsCount = 0
  const location = 'brand'

  const api = {
    _searchAssets,
    _searchFonts,
    _handleSuccessGetSearchAssets,
    _handleErrorGetSearchAssets,
    _handleSuccessGetSearchFonts,
    _handleErrorGetSearchFonts,
    _loadFonts,
    _onDeleteAsset,
    _getPreviewAssets,
    _removeObjectsByAssetId
  }
  this.getApi = () => api

  const deregisterSearchAssets = $scope.$on('searchAssets', ($event, searchTerm) => {
    $scope.searchTerm = searchTerm
    $scope.assetsTop = 18
    $scope.assetsCount = 0
    $scope.assets = []
    $scope.fontsTop = 18
    $scope.fontsCount = 0
    $scope.fonts = []

    if (searchTerm) {
      $scope.flags.loadingAssets = true
      api._searchAssets($scope.assetsTop, 0, $scope.searchTerm)
      $scope.flags.loadingFonts = true
      api._searchFonts($scope.fontsTop, 0, $scope.searchTerm)
    }
  })

  const deregisterSuccessArchiveAsset = $scope.$on('successArchiveAsset', () => {
    api._searchAssets($scope.assetsTop, 0, $scope.searchTerm)
    api._searchFonts($scope.fontsTop, 0, $scope.searchTerm)
  })

  $scope.$on('$destroy', () => {
    deregisterSearchAssets()
    deregisterSuccessArchiveAsset()
  })

  $scope.openPreview = async (asset) => {
    AssetService.getAssetDetailsById(asset.id).then(asset => {
      AssetPreviewService.openAssetPreview({
        asset: asset,
        getPreviewAssets: api._getPreviewAssets,
        location,
        onDeleteAsset: (sectionId, assetId) => {
          api._onDeleteAsset(sectionId, assetId)
        }
      })
    })
  }

  $scope.skipAssetsPagingTo = function (token) {
    $scope.flags.loadingAssets = true
    api._searchAssets($scope.assetsTop, token, $scope.searchTerm)
  }

  $scope.skipFontsPagingTo = function (token) {
    $scope.flags.loadingFonts = true
    api._searchFonts($scope.fontsTop, token, $scope.searchTerm)
  }

  function _searchAssets (top, skipToken, searchTerm) {
    BrandService.getBrandSectionAssetsBySearch({
      top: top,
      skip: top * skipToken,
      searchTerm: searchTerm
    }).then(api._handleSuccessGetSearchAssets).catch(api._handleErrorGetSearchAssets)
  }

  function _searchFonts (top, skipToken, searchTerm) {
    BrandService.searchBrandFonts({
      top: top,
      skip: top * skipToken,
      searchTerm: searchTerm
    }).then(api._loadFonts).then(api._handleSuccessGetSearchFonts).catch(api._handleErrorGetSearchFonts)
  }

  function _handleSuccessGetSearchAssets (response) {
    $scope.assets = []

    $timeout(() => {
      $scope.assets = response.d.results
      $scope.assetsCount = response.d.__count
      $scope.flags.loadingAssets = false
    }, 100)
  }

  function _handleErrorGetSearchAssets () {
    $scope.flags.loadingAssets = false
  }

  function _handleSuccessGetSearchFonts (response) {
    $scope.fonts = []

    $timeout(() => {
      $scope.fonts = response.d.results
      $scope.fontsCount = response.d.__count
      $scope.flags.loadingFonts = false
    }, 100)
  }

  function _handleErrorGetSearchFonts () {
    $scope.flags.loadingFonts = false
  }

  function _loadFonts (response) {
    BrandFontsService.loadFontsOnCSS(response.d.results)
    return response
  }

  function _onDeleteAsset (sectionId, assetId) {
    MessageService.warning({
      title: $translate.instant('warning'),
      text: $translate.instant('areYouSureDeleteAssetSingular'),
      confirmButton: $translate.instant('yesImSure'),
      cancelButton: $translate.instant('cancel'),
      closeOnConfirm: true,
      press: function (shouldDelete) {
        if (shouldDelete) {
          BrandService.unlinkBrandSectionAsset(sectionId, assetId)
            .then(() => {
              ToastService.defaultSuccessToast()
              $rootScope.$broadcast('successUnlinkBrandSectionAsset')
              $timeout(() => {
                const newAssets = api._removeObjectsByAssetId($scope.assets, assetId)
                $scope.assets = newAssets
                $rootScope.$emit('onDeleteAsset', { assetId, shouldClose: true })
              })
            })
            .catch(ToastService.defaultErrorToast)
        }
      }
    })
  }

  function _removeObjectsByAssetId (assets, assetId) {
    return assets.filter(asset => asset.id !== assetId)
  }

  function _getPreviewAssets () {
    const deferred = $q.defer()
    $timeout(() => {
      deferred.resolve({
        assets: $scope.assets,
        count: $scope.assets.length
      })
    }, 100, true)
    return deferred.promise
  }
}

export { SearchResultController }
